import React from 'react'
import { connect } from 'redaction'

import SubscriptionBlock from 'components/smartSearch/SubscriptionBlock/SubscriptionBlock'
import Sidebar from 'components/smartSearch/Sidebar/Sidebar'

import CategoryLinks from './CategoryLinks/CategoryLinks'
import BrandLinks from './BrandLinks/BrandLinks'
import GenderLinks from './GenderLinks/GenderLinks'
import OtherLinks from './OtherLinks/OtherLinks'


const SEOSidebar = ({ data: { pathname, gender, brands, tags }, fullWidth }) => (
  <Sidebar fullWidth={fullWidth}>
    <SubscriptionBlock />
    <CategoryLinks pathname={pathname} gender={gender} />
    <BrandLinks brands={brands} gender={gender} />
    <GenderLinks pathname={pathname} gender={gender} />
    <OtherLinks pathname={pathname} gender={gender} tags={tags} />
  </Sidebar>
)

export default connect({
  data: 'view.seoPage',
})(SEOSidebar)
